import React, { forwardRef } from "react";
import classNames from "classnames";
import { Icon } from "../icon";
import { useConfig } from "../_util/config-context";
import { callBoth } from "../_util/call-both";
export var TabItem = forwardRef(function (_a, ref) {
    var label = _a.label, onClick = _a.onClick, actived = _a.actived, disabled = _a.disabled, onClose = _a.onClose, render = _a.render, className = _a.className, style = _a.style;
    var classPrefix = useConfig().classPrefix;
    var children = render(React.createElement(React.Fragment, null, label));
    var handleClick = disabled ? null : onClick;
    return (React.createElement("li", { className: classNames(classPrefix + "-tabs__tabitem", className), style: style, ref: ref },
        React.cloneElement(children, {
            className: classNames(classPrefix + "-tabs__tab", children.props.className, {
                "is-active": actived,
                "is-disabled": disabled,
            }),
            onClick: callBoth(handleClick, children.props.onClick),
        }),
        onClose && (React.createElement("a", { className: classPrefix + "-tabs__remove", onClick: onClose },
            React.createElement(Icon, { type: "dismiss" })))));
});
TabItem.displayName = "TabItem";
//# sourceMappingURL=TabItem.js.map